import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-185d3043"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "register-page" }
const _hoisted_2 = { class: "register-page__container" }
const _hoisted_3 = { class: "register-page__title" }
const _hoisted_4 = { class: "register-page__content-wrapper" }
const _hoisted_5 = { class: "register-page__row" }
const _hoisted_6 = { class: "register-page__input-group" }
const _hoisted_7 = {
  class: "label",
  id: "register.name"
}
const _hoisted_8 = { class: "register-page__input-group" }
const _hoisted_9 = {
  class: "label",
  id: "register.lastName"
}
const _hoisted_10 = { class: "register-page__input-group" }
const _hoisted_11 = {
  class: "label",
  id: "register.mobilePhone"
}
const _hoisted_12 = { class: "register-page__input-group" }
const _hoisted_13 = {
  class: "label",
  id: "register.email"
}
const _hoisted_14 = { class: "register-page__input-group" }
const _hoisted_15 = {
  class: "label",
  id: "register.line1"
}
const _hoisted_16 = { class: "register-page__row" }
const _hoisted_17 = { class: "register-page__input-group" }
const _hoisted_18 = {
  class: "label",
  id: "register.zip"
}
const _hoisted_19 = { class: "register-page__input-group" }
const _hoisted_20 = {
  class: "label",
  id: "register.city"
}
const _hoisted_21 = { class: "register-page__input-group" }
const _hoisted_22 = {
  class: "label",
  id: "register.country"
}
const _hoisted_23 = { class: "register-page__input-group" }
const _hoisted_24 = {
  class: "label",
  id: "register.password"
}
const _hoisted_25 = { class: "register-page__input-group" }
const _hoisted_26 = {
  class: "label",
  id: "register.confirmPassword"
}
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = {
  key: 0,
  class: "error-message"
}
const _hoisted_30 = {
  key: 0,
  class: "register-page__success-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_field = _resolveComponent("v-field")!
  const _component_v_message = _resolveComponent("v-message")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t("RegisterPage.Register")), 1)
      ]),
      _createVNode(_component_v_form, { onSubmit: _ctx.onSubmit }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("Common.Name")), 1),
                _createVNode(_component_v_field, {
                  name: "name",
                  type: "text",
                  id: "register.name",
                  class: "input form-control",
                  modelValue: _ctx.registerModel.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.registerModel.name) = $event)),
                  rules: "required",
                  label: _ctx.$t('Common.Name'),
                  placeholder: _ctx.$t("ContactForm.FirstNamePlaceholder")
                }, null, 8, ["modelValue", "label", "placeholder"]),
                _createVNode(_component_v_message, { name: "name" })
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("Common.LastName")), 1),
                _createVNode(_component_v_field, {
                  name: "lastName",
                  type: "text",
                  id: "register.lastName",
                  class: "input form-control",
                  modelValue: _ctx.registerModel.lastName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.registerModel.lastName) = $event)),
                  rules: "required",
                  label: _ctx.$t('Common.LastName'),
                  placeholder: _ctx.$t("ContactForm.LastNamePlaceholder")
                }, null, 8, ["modelValue", "label", "placeholder"]),
                _createVNode(_component_v_message, { name: "lastName" })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("Common.MobilePhone")), 1),
              _createVNode(_component_v_field, {
                name: "mobilePhone",
                type: "number",
                id: "register.mobilePhone",
                class: "input form-control",
                modelValue: _ctx.registerModel.mobilePhone,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.registerModel.mobilePhone) = $event)),
                rules: _ctx.validatePhone,
                label: _ctx.$t('Common.MobilePhone'),
                placeholder: _ctx.$t("ContactForm.PhoneNumberPlaceholder")
              }, null, 8, ["modelValue", "rules", "label", "placeholder"]),
              _createVNode(_component_v_message, {
                class: "error",
                name: "mobilePhone"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Registererror.PhoneNotValid')), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("Common.EmailAddress")), 1),
              _createVNode(_component_v_field, {
                name: "email",
                type: "email",
                id: "register.email",
                class: "input form-control",
                modelValue: _ctx.registerModel.email,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.registerModel.email) = $event)),
                rules: "required|email",
                label: _ctx.$t('Common.EmailAddress'),
                placeholder: _ctx.$t("ContactForm.EmailPlaceholder")
              }, null, 8, ["modelValue", "label", "placeholder"]),
              _createVNode(_component_v_message, { name: "email" })
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("Common.Address1")), 1),
              _createVNode(_component_v_field, {
                name: "line1",
                type: "text",
                id: "register.line1",
                class: "input form-control",
                modelValue: _ctx.registerModel.line1,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.registerModel.line1) = $event)),
                rules: "required",
                label: _ctx.$t('Common.Address1'),
                placeholder: _ctx.$t("ContactForm.AddressPlaceholder")
              }, null, 8, ["modelValue", "label", "placeholder"]),
              _createVNode(_component_v_message, { name: "line1" })
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t("Common.ZipCode")), 1),
                _createVNode(_component_v_field, {
                  name: "zip",
                  type: "text",
                  id: "register.zip",
                  class: "input form-control",
                  modelValue: _ctx.registerModel.zip,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.registerModel.zip) = $event)),
                  rules: "required",
                  label: _ctx.$t('Common.ZipCode'),
                  placeholder: _ctx.$t("ContactForm.ZipCodePlaceholder")
                }, null, 8, ["modelValue", "label", "placeholder"]),
                _createVNode(_component_v_message, { name: "zip" })
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t("Common.City")), 1),
                _createVNode(_component_v_field, {
                  name: "city",
                  type: "text",
                  id: "register.city",
                  class: "input form-control",
                  modelValue: _ctx.registerModel.city,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.registerModel.city) = $event)),
                  rules: "required",
                  label: _ctx.$t('Common.City'),
                  placeholder: _ctx.$t("ContactForm.CityPlaceholder")
                }, null, 8, ["modelValue", "label", "placeholder"]),
                _createVNode(_component_v_message, { name: "city" })
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t("Common.Country")), 1),
              _createVNode(_component_v_field, {
                name: "country",
                type: "text",
                id: "register.country",
                class: "input form-control",
                modelValue: _ctx.registerModel.country,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.registerModel.country) = $event)),
                rules: "required",
                label: _ctx.$t('Common.Country'),
                placeholder: _ctx.$t("Common.Country")
              }, null, 8, ["modelValue", "label", "placeholder"]),
              _createVNode(_component_v_message, { name: "country" })
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("RegisterPage.Password")), 1),
              _createVNode(_component_v_field, {
                name: "password",
                type: "password",
                id: "register.password",
                class: "input form-control",
                modelValue: _ctx.registerModel.password,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.registerModel.password) = $event)),
                rules: "required",
                label: _ctx.$t('Common.Password'),
                placeholder: _ctx.$t('LoginPage.PasswordPlaceholder')
              }, null, 8, ["modelValue", "label", "placeholder"]),
              _createVNode(_component_v_message, { name: "password" })
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("Common.ConfirmPassword")), 1),
              _createVNode(_component_v_field, {
                name: "confirmPassword",
                type: "password",
                id: "register.confirmPassword",
                class: "input form-control",
                modelValue: _ctx.registerModel.confirmPassword,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.registerModel.confirmPassword) = $event)),
                rules: "required",
                label: _ctx.$t('Common.ConfirmPassword'),
                placeholder: _ctx.$t('LoginPage.PasswordPlaceholder')
              }, null, 8, ["modelValue", "label", "placeholder"]),
              _createVNode(_component_v_message, { name: "confirmPassword" })
            ]),
            _createElementVNode("button", {
              disabled: !_ctx.isFormValid() || !_ctx.validatePhone(_ctx.registerModel.mobilePhone),
              type: "submit",
              class: "button--primary button--base"
            }, _toDisplayString(_ctx.$t("Common.RegisterButton")), 9, _hoisted_27),
            _createElementVNode("div", {
              class: "register-page__policy-text",
              innerHTML: _ctx.policy
            }, null, 8, _hoisted_28),
            (_ctx.errorMessage)
              ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_ctx.errorMessage), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"]),
      (_ctx.success)
        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("Common.RegistrationSuccess")), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}